import React from 'react';
import { Box, Stack, Typography, Chip } from '@mui/material';

const FilterField = ({ label, count, children }) => (
  <Box>
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 0.6 }}>
      <Typography variant="caption"
        sx={{ color: '#546E7A', fontWeight: 600, letterSpacing: 0.8, fontSize: 10, textTransform: 'uppercase' }}>
        {label}
      </Typography>
      {count > 0 && (
        <Chip label={count} size="small"
          sx={{ height: 14, fontSize: 9, backgroundColor: '#1565C0', color: '#fff', '& .MuiChip-label': { px: 0.8 } }} />
      )}
    </Stack>
    {children}
  </Box>
);

export default FilterField;